import { render, staticRenderFns } from "./SkillFeedbackRequest.vue?vue&type=template&id=b02d4ee4&"
import script from "./SkillFeedbackRequest.vue?vue&type=script&lang=js&"
export * from "./SkillFeedbackRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports